import { useEffect, useState } from 'react';

import { type ApolloClientType } from '@atlassian/ptc-graphql-client';

import { getApolloClient, getGatewayClient } from '../clients/apollo-client';

export function useSetupApolloClient(cloudId: string) {
	const [apolloClient, setApolloClient] = useState<ApolloClientType>(
		getApolloClient({
			getCloudId: () => cloudId,
		}),
	);
	const gatewayClient = getGatewayClient();

	// setup directory Apollo client
	useEffect(() => {
		if (!cloudId) {
			return;
		}

		const apolloClient = getApolloClient({
			getCloudId: () => cloudId,
		});

		/**
		 * Enables the field @cloudId in apollo queries
		 */
		apolloClient.writeData({
			data: {
				cloudId,
			},
		});

		setApolloClient(apolloClient);
	}, [cloudId]);

	// setup gateway Apollo client
	useEffect(() => {
		/**
		 * Enables the field @cloudId in apollo queries
		 */
		gatewayClient.writeData({
			data: {
				cloudId: cloudId || 'None',
			},
		});
	}, [cloudId, gatewayClient]);

	return apolloClient;
}
